const CreateEditSpeakerInputs = ({
  cancelButtonRef,
  setOpen,
  bookedDate,
  createSpeakerBooking,
  inputs,
  setInputs,
  editSpeakerBooking,
}) => {
  const create = (e) => {
    e.preventDefault();
    if (inputs?.id) {
      return editSpeakerBooking(inputs);
    }
    createSpeakerBooking({
      bookedDate,
      ...inputs,
    });
  };

  return (
    <form onSubmit={create}>
      <div className="mb-6 grid gap-2">
        <div>
          <label
            htmlFor="first_name"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Ομιλητής
          </label>
          <input
            onChange={(e) =>
              setInputs((prevState) => ({
                ...prevState,
                speakerName: e.target.value,
              }))
            }
            value={inputs.speakerName}
            type="text"
            id="first_name"
            className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            required
          />
        </div>
        <div>
          <label
            htmlFor="company"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Εκκλησία
          </label>
          <input
            onChange={(e) =>
              setInputs((prevState) => ({
                ...prevState,
                meetingHouse: e.target.value,
              }))
            }
            value={inputs.meetingHouse}
            type="text"
            id="company"
            className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            required
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">
            Αριθμός ομιλίας
          </label>
          <input
            onChange={(e) =>
              setInputs((prevState) => ({
                ...prevState,
                number: e.target.value,
              }))
            }
            value={inputs.number}
            type="number"
            id="number"
            className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder=""
            pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
            required
          />
        </div>
      </div>
      <div className=" px-4 py-3 flex gap-2 ">
        <button
          type="button"
          className="mt-3 bg-gray-100 inline-flex w-full focus:outline-none justify-center rounded-md px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 sm:mt-0 sm:w-auto"
          onClick={() => setOpen(false)}
          ref={cancelButtonRef}
        >
          Πίσω
        </button>
        <button
          type="submit"
          className="mt-3 inline-flex bg-emerald-500 w-full focus:outline-none justify-center rounded-md text-white px-3 py-2 text-sm font-semibold shadow-sm hover:bg-emerald-400 sm:mt-0 sm:w-auto"
          ref={cancelButtonRef}
        >
          Αποθήκευση
        </button>
      </div>
    </form>
  );
};

export default CreateEditSpeakerInputs;
